import { useState } from "react";
import { Container, Row, Col, Card, Form } from "react-bootstrap";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

export default function RollinInDaisies() {
    // State
    const [category, setCategory] = useState("premade"); // Default category: Pre-Made
    const [servingSize, setServingSize] = useState("4");
    const [eventSize, setEventSize] = useState(""); // Number of people for events
    const [delivery, setDelivery] = useState(false);
    const [selectedFlavors, setSelectedFlavors] = useState([]);
    const [dietaryRestrictions, setDietaryRestrictions] = useState([]);
    const [additionalNotes, setAdditionalNotes] = useState("");

    // Pricing logic
    const premadePrices = { "4": 40, "6": 36, "15": 90 };
    const basePrice = category === "premade"
        ? premadePrices[servingSize] || 0
        : (eventSize ? eventSize * 6 : 0);
    const finalPrice = delivery ? basePrice + 90 : basePrice;

    // Image selection logic
    const imageSrc = category === "premade"
        ? `/rollin-in-daisies/cinnamonrolls-${servingSize}.png`
        : eventSize ? `/rollin-in-daisies/bigevent.png` : "";

    // Flavor & Dietary Options
    const flavorOptions = [
        { value: "classic cinnamon", label: "Classic Cinnamon" },
        { value: "creamy cocoa", label: "Creamy Cocoa" },
        { value: "strawberry lemon", label: "Strawberry Lemon" },
        { value: "zesty lemon", label: "Zesty Lemon" },
        { value: "sweet espresso", label: "Sweet Espresso" },
        { value: "blueberry cobbler", label: "Blueberry Cobbler" },
    ];

    const dietaryOptions = [
        { value: "gluten free", label: "Gluten Free" },
        { value: "nut free", label: "Nut Free" },
    ];

    return (
        <Container className="mt-4">
            <Card className="p-4 shadow" style={{ position: "relative", overflow: "visible" }}>
                <h2 className="text-center mb-4">Rollin' In Daisies</h2>
                <Row>
                    {/* Left Column: Controls */}
                    <Col md={6} className="pb-4 pb-md-0">
                        <Card className="p-3" style={{ position: "relative", overflow: "visible" }}>
                            {/* Category Selection */}
                            <Form.Group className="mb-3">
                                <Form.Label>Order Type</Form.Label>
                                <Form.Select value={category} onChange={(e) => setCategory(e.target.value)}>
                                    <option value="premade">Pre-Made (Frozen)</option>
                                    <option value="bigEvent">Private Event Booking</option>
                                </Form.Select>
                            </Form.Group>

                            {/* Pre-Made Selection */}
                            {category === "premade" && (
                                <Form.Group className="mb-3">
                                    <Form.Label>Serving Size</Form.Label>
                                    <Form.Select value={servingSize} onChange={(e) => setServingSize(e.target.value)}>
                                        <option value="4">4 (Jumbo) - $40</option>
                                        <option value="6">6 - $36</option>
                                        <option value="15">15 - $90</option>
                                    </Form.Select>
                                </Form.Group>
                            )}

                            {/* Big Event Selection */}
                            {category === "bigEvent" && (
                                <>
                                    <Form.Group className="mb-3">
                                        <Form.Label># of People</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Enter number"
                                            value={eventSize}
                                            onChange={(e) => setEventSize(e.target.value)}
                                            min="1"
                                        />
                                    </Form.Group>

                                    {/* Delivery Toggle */}
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            label="Include Delivery (+$90)"
                                            checked={delivery}
                                            onChange={() => setDelivery(!delivery)}
                                        />
                                    </Form.Group>
                                </>
                            )}

                            {/* Flavor Selection */}
                            <Form.Group className="mb-3">
                                <Form.Label>Flavor</Form.Label>
                                <Select
                                    options={flavorOptions}
                                    value={flavorOptions.find(option => option.value === selectedFlavors) || null}
                                    onChange={(selected) => setSelectedFlavors(selected ? selected.value : "")}
                                />
                            </Form.Group>

                            {/* Dietary Restrictions */}
                            <Form.Group className="mb-3">
                                <Form.Label>Dietary Restrictions</Form.Label>
                                <Select
                                    options={dietaryOptions}
                                    isMulti
                                    value={dietaryOptions.filter(option => dietaryRestrictions.includes(option.value))}
                                    onChange={(selected) => setDietaryRestrictions(selected.map(s => s.value))}
                                />
                            </Form.Group>

                            {/* Additional Notes */}
                            <Form.Group className="mb-3">
                                <Form.Label>Additional Notes</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={additionalNotes}
                                    onChange={(e) => setAdditionalNotes(e.target.value)}
                                    placeholder="Any special requests?"
                                />
                            </Form.Group>

                            {/* Send Quote Request Button */}
                            <button
                                
                                onClick={() => alert("Email sent to RollinInDaisies. Stay tuned - will reach out soon!")}
                            >
                                Send Quote Request
                            </button>

                        </Card>
                    </Col>

                    {/* Right Column: Image & Price */}
                    <Col md={6} className="d-flex flex-column align-items-center">
                        {imageSrc ? (
                            <img
                                src={imageSrc}
                                alt="Cake Preview"
                                style={{
                                    width: "100%",
                                    maxWidth: "300px",
                                    height: "auto",
                                    marginBottom: "20px",
                                    borderRadius: "10px",
                                }}
                            />
                        ) : (
                            <p className="text-muted">Select options to preview</p>
                        )}

                        {/* Price Display */}
                        <h5>Estimated Price:</h5>
                        <h4 >${Math.round(finalPrice)}</h4>
                    </Col>
                </Row>
            </Card>
        </Container>
    );
}
